import { createIFramedMicroapp } from './utils.js';
import { faker } from 'https://cdn.jsdelivr.net/npm/@faker-js/faker/+esm';

// Generate and log a random user name and email using faker
const randomName = faker.person.fullName();
const randomEmail = faker.internet.email();
console.log(`Random User: ${randomName}, Email: ${randomEmail}`);

/**
 * Initializes LogRocket with specified child domains and identifies the user.
 */
const initLogRocket = () => {
  window.emui.logRocketConfig.childDomains = [
    'https://vinothvk.com',
    'https://beta.vinothvk.com',
    'https://vinothkumarvk.com',
  ];
  const options = {
    isReact: false,
    release: '26.1.0',
    // dom : {
    //   hiddenAttributes: [],
    //   inputSanitizer: true,
    //   textSanitizer: true,
    // }
  };
  window.emuiLogrocket.initLogRocket(options);
  window.emui.logRocket.identify(randomEmail, {
    name: randomName,
    email: randomEmail,
  });
};

/**
 * make some sample fetch calls to demonstrate network logging
 */
const makeSampleFetchCalls = () => {
  fetch('https://jsonplaceholder.typicode.com/posts/1')
    .then((response) => response.json())
    .catch((error) => console.error('Error fetching post:', error));

  fetch('https://jsonplaceholder.typicode.com/users/1')
    .then((response) => response.json())
    .catch((error) => console.error('Error fetching user:', error));

  // log a metric
  window.emui.logRocket.track('fetch_done', {
    timestamp: new Date().toISOString(),
  });
};

/**
 * Calculates the monthly payment for a loan.
 * @returns {void}
 */
const calculateMonthlyPayment = () => {
  const monthlyPaymentEl = document.getElementById('monthly-payment');
  const principal = parseFloat(document.getElementById('loan-amount').value);
  const years = parseFloat(document.getElementById('loan-term').value);
  const interestRate =
    parseFloat(document.getElementById('interest-rate').value) / 100;

  if (isNaN(principal) || isNaN(years) || isNaN(interestRate)) {
    monthlyPaymentEl.textContent = 'Please enter valid numbers.';
    return;
  }

  const monthlyInterestRate = interestRate / 12;
  const numberOfPayments = years * 12;

  const monthlyPayment =
    (principal * monthlyInterestRate) /
    (1 - (1 + monthlyInterestRate) ** -numberOfPayments);
  monthlyPaymentEl.textContent = `Monthly Payment: $${monthlyPayment.toFixed(
    2,
  )}`;
  makeSampleFetchCalls();
};

/**
 * Creates iframes for the microapps.
 */
const createIframes = () => {
  createIFramedMicroapp(`./microapp1-same-domain.html`);
  createIFramedMicroapp(
    `https://vinothkumarvk.com/microapp2-cross-domain.html`,
    { height: '400px' },
  );
};

/**
 * Loads the main application functionalities.
 */
const load = () => {
  // Initialize LogRocket if available
  if (window.emuiLogrocket) initLogRocket();
  // Set up event listeners for buttons
  document.getElementById('applicant-name').value = randomName;
  document.getElementById('applicant-email').textContent = randomEmail;
  const calculateBtn = document.getElementById('calculate-btn');
  calculateBtn.addEventListener('click', calculateMonthlyPayment);
  const loadAppsBtn = document.getElementById('load-child-apps-btn');
  loadAppsBtn.addEventListener('click', createIframes);
};

/**
 * Creates and displays a cookie consent banner dialog.
 * The dialog allows users to accept or reject all cookies.
 * Sets the `window.OnetrustActiveGroups` variable based on user choice,
 * closes the dialog, and calls the `load()` function.
 *
 * @function
 */
const createCookieBannerDialog = () => {
  const dialog = document.createElement('dialog');
  dialog.id = 'cookie-consent-dialog';
  dialog.innerHTML = `
    <form method="dialog">
      <h2>Cookie Consent</h2>
      <p>We use cookies to enhance your experience. By clicking "Accept All", you consent to the use of all cookies. You can also choose to "Reject All" cookies.</p>
      <menu>
        <button id="accept-all" value="accept">Accept All</button>
        <button id="reject-all" value="reject">Reject All</button>
      </menu>
    </form>
  `;
  document.body.appendChild(dialog);
  dialog.showModal();

  const acceptBtn = document.getElementById('accept-all');
  const rejectBtn = document.getElementById('reject-all');

  acceptBtn.addEventListener('click', () => {
    window.OnetrustActiveGroups = 'C0002,C0003';
    dialog.close();
    load();
  });

  rejectBtn.addEventListener('click', () => {
    window.OnetrustActiveGroups = '';
    dialog.close();
    load();
  });
};

/**
 * event handler for the window load event.
 * @returns {void}
 */
const onLoad = () => {
  // if cookie consent query param is present, do not show cookie banner
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('trackingConsent') === 'false') {
    createCookieBannerDialog();
    return;
  } else {
    //window.OnetrustActiveGroups = 'C0002,C0003';
    window.emui = window.emui || {};
    window.emui.dangerouslyOverrideOneTrustConsent = true;
    load();
  }
};

window.addEventListener('load', onLoad);
